import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';

document.addEventListener('alpine:init', () => {
  Alpine.store('mobileSubMenu', {
    on: '',

    toggle(value: string) {
      this.on = value;
    },
  });
});
